<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2">
                                <customer-sidebar v-if="currentUser.role == 'player'"></customer-sidebar>
                                <vendor-sidebar v-else></vendor-sidebar>
                            </div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Profil</h2>
                        </div>

                        <div class="alert alert-warning alert-dismissible fade show rounded-xl"
                            :class="{ 'd-none': currentUser.phone_number }" role="alert">
                            Merci de renseigner votre numéro téléphone <a href="/my/profile"><b>ici</b></a> pour valider
                            votre compte.
                        </div>
                        <div class="alert alert-warning alert-dismissible fade show"
                            :class="{ 'd-none': currentUser.is_verified || !currentUser.phone_number }" role="alert">
                            Merci de vérifier votre numéro téléphone <a href="/otp-verification"><b>ici</b></a> pour
                            valider votre compte.
                        </div>

                        <!-- Profile Settings Form -->
                        <form @submit.prevent="editProfile">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Nom Complet</label>
                                        <input type="text" id="first_name" class="form-control" v-model="user.full_name"
                                            required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Email</label>
                                        <input type="text" id="first_name" class="form-control border-0"
                                            v-model="user.email" disabled />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Délégation</label>
                                        <v-select :options="delegations" v-model="user.delegation" label="option"
                                            :reduce="option => option" class="custom-vs form-control input">
                                            <template #option="{ option }">
                                                <span><b>{{ option.split(', ')[0] }}</b>, {{ option.split(', ')[1] }}</span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Rejoint le</label>
                                        <input type="text" id="whatsapp" class="form-control" v-model="joiningDate"
                                            disabled />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>N° Téléphone</label>
                                        <input type="text" id="phone" class="form-control" v-model="user.phone_number"
                                            pattern="[1-9][0-9]{7}" required :disabled="phoneNumber" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>N° Whatsapp</label>
                                        <input type="text" id="whatsapp" class="form-control"
                                            v-model="user.whatsapp_number" pattern="[1-9][0-9]{7}" required />
                                    </div>
                                </div>
                            </div>
                            <div class="submit-section">
                                <button type="submit" class="btn btn-primary btn-rounded submit-btn">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Enregistrer</label>
                                </button>
                            </div>
                        </form>
                        <!-- /Profile Settings Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style scoped>
.custom-vs .vs__search,
.custom-vs .vs__search:focus {
    border: none;
}

.custom-vs .vs__search::placeholder,
.custom-vs .vs__dropdown-toggle {
    background: transparent;
    border: none;
    width: 100%;
    height: 100%;
}

.custom-vs .vs__actions {
    display: none;
}

.custom-vs .vs__dropdown-menu {
    top: calc(100% + 1px);
    padding: 0;
    width: max-content !important;
}

.custom-vs .vs__selected-options {
    align-items: center;
    overflow: hidden;
}

.custom-vs .vs__selected {
    white-space: nowrap;
    position: absolute;
}

.custom-vs .v__selected-options,
.custom-vs .v__selected,
.custom-vs .v__search {
    padding-left: 0 !important;
    margin-left: 0 !important;
}

.vs--open .vs__selected {
    width: 100%;
}

.custom-vs .vs__dropdown-option--highlight {
    background: whitesmoke;
    color: black;
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        "vendor-sidebar": VendorSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        joiningDate() {
            return (moment(this.$store.getters.currentUser.created_at).format('LL')).toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase())
        }
    },
    data() {
        return {
            delegations: [],
            user: {
                full_name: '',
                email: '',
                phone_number: '',
                whatsapp_number: '',
                delegation: '',
                created_at: ''
            },
            phoneNumber: '',
            whatsappNumber: ''
        }
    },
    mounted() {
        this.getDelegations()

        this.user = this.currentUser
        this.phoneNumber = this.user.phone_number
        this.whatsappNumber = this.user.whatsapp_number
    },
    methods: {
        formatDate(date) {

        },
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async editProfile() {
            if (!this.user.delegation) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Merci de renseigner votre délégation.'
                })
                return false
            }
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            setTimeout(() => {
                api.patch('/users/me', this.user)
                    .then(response => {
                        this.$store.dispatch('modal/triggerModal', {
                            icon: 'check',
                            icon_color: 'text-success',
                            title: 'Succès',
                            detail: 'Votre profil a été mis à jour.'
                        })
                    })
                    .catch(error => {
                        this.error = error.response.data?.detail
                        this.$store.dispatch('modal/triggerModal', {
                            icon: 'error',
                            icon_color: 'text-danger',
                            title: 'Erreur',
                            detail: (this.error) ? this.error : "Une erreur s'est produite lors de la mise à jour du profil."
                        })
                    })
                    .finally(() => {
                        $('.submit-section button').removeAttr('disabled')
                        $('.submit-section button span').addClass('d-none')
                    });
            }, 1500);
        }
    },
};
</script>
